import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './TermsPage.css';

const TermsPage = () => {
  const handleEnrollClick = () => {
    window.location.href = '/#home';
  };

  useEffect(() => {
    // Fix all anchor links on the page
    const fixAnchorLinks = () => {
      const anchors = document.querySelectorAll('a[href^="#"]');
      
      anchors.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const hash = anchor.getAttribute('href');
          window.location.href = '/' + hash;
        });
      });
    };

    setTimeout(fixAnchorLinks, 100);
    
    const observer = new MutationObserver(fixAnchorLinks);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className="terms-page">
      <Header onEnrollClick={handleEnrollClick} />
      
      <main className="terms-main">
        <div className="terms-container" style={{marginTop : '50PX'}}>
          {/* Header */}
          <header className="terms-header">
            <h1>Terms and Conditions</h1>
            <div className="meta-info">
              <p><strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </header>

          {/* Content */}
          <div className="terms-content">
            
            <section className="terms-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the DYLORA 1+1 Internship Program website and enrolling in our program, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our website or services.
              </p>
            </section>

            <section className="terms-section">
              <h2>2. Program Description</h2>
              <p>The DYLORA 1+1 Internship Program consists of:</p>
              <ul>
                <li><strong>1 Month of Professional Training:</strong> Live interactive sessions covering industry-relevant skills</li>
                <li><strong>1 Month of Hands-on Internship:</strong> Practical experience with real industry projects</li>
                <li><strong>Career Support:</strong> Resume building, LinkedIn optimization, interview preparation</li>
                <li><strong>Certification:</strong> Two verified certificates upon successful completion</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>3. Enrollment and Payment</h2>
              
              <h3>3.1 Enrollment Process</h3>
              <ul>
                <li>Complete the online registration form with accurate information</li>
                <li>Receive confirmation email with WhatsApp group link</li>
                <li>Join WhatsApp group for payment instructions and program details</li>
                <li>Complete payment of ₹599 to confirm enrollment</li>
              </ul>

              <h3>3.2 Payment Terms</h3>
              <ul>
                <li>Program fee: ₹599 (including GST)</li>
                <li>Payment must be completed within 48 hours of registration</li>
                <li>Payment methods will be shared via WhatsApp</li>
                <li>No cash payments accepted</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>4. Program Requirements</h2>
              
              <div className="requirements-table">
                <div className="table-header">
                  <div className="col-requirement">Requirement</div>
                  <div className="col-description">Details</div>
                </div>
                
                <div className="table-row">
                  <div className="col-requirement">Attendance</div>
                  <div className="col-description">Minimum 80% attendance required for certificate eligibility</div>
                </div>
                
                <div className="table-row">
                  <div className="col-requirement">Assignments</div>
                  <div className="col-description">Timely submission of all assigned tasks and projects</div>
                </div>
                
                <div className="table-row">
                  <div className="col-requirement">Participation</div>
                  <div className="col-description">Active participation in sessions and group activities</div>
                </div>
                
                <div className="table-row">
                  <div className="col-requirement">Code of Conduct</div>
                  <div className="col-description">Professional behavior and respect for all participants</div>
                </div>
              </div>
            </section>

            <section className="terms-section">
              <h2>5. Certificate Policy</h2>
              
              <h3>5.1 Certificate Issuance</h3>
              <ul>
                <li>Training Certificate: Issued after successful completion of 1-month training</li>
                <li>Internship Certificate: Issued after successful completion of 1-month internship</li>
                <li>Certificates are digitally verified and can be shared on LinkedIn</li>
              </ul>

              <h3>5.2 Certificate Criteria</h3>
              <ul>
                <li>Complete all training modules and assignments</li>
                <li>Submit final internship project</li>
                <li>Maintain minimum required attendance</li>
                <li>Adhere to program code of conduct</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>6. Refund Policy</h2>
              
              <div className="refund-grid">
                <div className="refund-item">
                  <h3>Before Program Start</h3>
                  <p>Full refund available if requested 7 days before program commencement</p>
                </div>
                
                <div className="refund-item">
                  <h3>After Program Start</h3>
                  <p>No refunds after program commencement. Case-by-case consideration for emergencies</p>
                </div>
                
                <div className="refund-item">
                  <h3>Program Cancellation</h3>
                  <p>Full refund if DYLORA cancels the program for any reason</p>
                </div>
                
                <div className="refund-item">
                  <h3>Refund Process</h3>
                  <p>Refunds processed within 7-10 business days to original payment method</p>
                </div>
              </div>
            </section>

            <section className="terms-section">
              <h2>7. Intellectual Property</h2>
              
              <h3>7.1 DYLORA's Rights</h3>
              <ul>
                <li>All training materials, course content, and resources are proprietary</li>
                <li>Materials are for personal educational use only</li>
                <li>No redistribution, sharing, or commercial use without written permission</li>
              </ul>

              <h3>7.2 Student's Rights</h3>
              <ul>
                <li>You retain rights to projects and work created during the program</li>
                <li>You may showcase completed projects in your portfolio</li>
                <li>You may mention program completion on your resume and LinkedIn</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>8. Code of Conduct</h2>
              <p>All participants must adhere to the following:</p>
              
              <div className="conduct-list">
                <div className="conduct-item">
                  <div className="conduct-icon">✅</div>
                  <div className="conduct-content">
                    <strong>Professional Behavior:</strong> Respectful communication with mentors and peers
                  </div>
                </div>
                
                <div className="conduct-item">
                  <div className="conduct-icon">✅</div>
                  <div className="conduct-content">
                    <strong>Academic Integrity:</strong> No plagiarism or cheating in assignments
                  </div>
                </div>
                
                <div className="conduct-item">
                  <div className="conduct-icon">✅</div>
                  <div className="conduct-content">
                    <strong>Confidentiality:</strong> Respect privacy of other participants
                  </div>
                </div>
                
                <div className="conduct-item">
                  <div className="conduct-icon">✅</div>
                  <div className="conduct-content">
                    <strong>Timely Participation:</strong> Active and punctual participation in sessions
                  </div>
                </div>
              </div>
            </section>

            <section className="terms-section">
              <h2>9. Limitation of Liability</h2>
              <p>
                DYLORA provides the internship program "as is" without warranties of any kind. We are not responsible for:
              </p>
              <ul>
                <li>Technical issues beyond our control</li>
                <li>Internet connectivity problems at student's end</li>
                <li>Employment outcomes after program completion</li>
                <li>Individual learning outcomes which may vary</li>
                <li>Changes in program schedule due to unforeseen circumstances</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>10. Privacy</h2>
              <p>
                Your privacy is important to us. Our Privacy Policy governs the collection, use, and disclosure of your personal information. By using our services, you agree to the terms of our Privacy Policy.
              </p>
              <p className="note">
                <strong>Note:</strong> We may share your information with potential employers only with your explicit consent.
              </p>
            </section>

            <section className="terms-section">
              <h2>11. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. We will notify enrolled students of significant changes via email.
              </p>
              <p>
                Your continued use of our services after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section className="terms-section">
              <h2>12. Contact Information</h2>
              
              <div className="contact-info">
                <div className="contact-item">
                  <strong>For Terms Inquiries:</strong> contact@dylora.in
                </div>
                
                <div className="contact-item">
                  <strong>Phone Support:</strong> +91 70212 88082 (Mon-Fri, 10AM-6PM)
                </div>
                
                <div className="contact-item">
                  <strong>Address:</strong> Chembur, Mumbai, Maharashtra, India
                </div>
                
                <div className="contact-item">
                  <strong>Website:</strong> intern.dylora.in
                </div>
              </div>
            </section>

            <section className="terms-section acknowledgement">
              <h2>Acceptance</h2>
              <p>
                By enrolling in the DYLORA 1+1 Internship Program, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
              </p>
              <div className="signature">
                <p><strong>The DYLORA Team</strong></p>
                <p>DYLORA Internship Program</p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;